import React, { Component } from 'react';
import ScheduledServicePlan from '../../ssp/ScheduledServicePlan'
import './Item.css'
import {connect} from 'react-redux'
class Item extends Component {

  constructor(props) {
    super(props)

    this.state = {}
  }

  render() {
    let {messages} = this.props
    return(
  		<div>
        <h3>{messages['SSP']}</h3>
        <ScheduledServicePlan 
        
        />
  		</div>
  	)
  }

}
 
// export default Item;
export default Item = connect(
  (state) => ({messages: state.message.view.settings.Menu3.Item}),null,null,{withRef:true}
)(Item);



// WEBPACK FOOTER //
// ./src/view/settings/Menu3/Item.js